<template>
  <div>
    <v-container fluid>
      <Govem_bar />
      <base-material-card
        icon="mdi-calculator"
        title="ผลการเลื่อนค่าตอบแทนพนักงานราชการ (สถาบัน)"
        class="px-5 py-3"
      >
        <CompensationResultView />
      </base-material-card>
    </v-container>
  </div>
</template>

<script>
// ส่วนกลางเป็นผู้ประมวลผล (admin/gov_em/central_compensation) — สถาบันดูผล พิมพ์แบบรายงานให้ ผอ.ลงนาม และแนบไฟล์
// หน้าคำนวณเดิมของสถาบันเก็บไว้ที่ cal_compensation_legacy.vue (ไม่ได้ผูก route)
import Govem_bar from "../../../components/iven/govem_bar.vue";
import CompensationResultView from "../../../components/govem/CompensationResultView.vue";

export default {
  name: "IvenCompensationResult",
  components: { Govem_bar, CompensationResultView }
};
</script>
